import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import Container from '../Container';
import FancyTitle from '../fancy-title';
import { getStoryblokAlt } from '../../helpers/common';

const ICON_COLOR_FILTER_PREFIX = 'reference-fact-icon-color';

export function ReferenceFactItem({ blok }) {
  return (
    <div
      {...storyblokEditable(blok)}
      className="hidden"
      aria-hidden="true"
    />
  );
}

export default function ReferenceFactsSection({ blok }) {
  const facts = Array.isArray(blok?.facts) ? blok.facts : [];
  const iconFilterId = `${ICON_COLOR_FILTER_PREFIX}-${blok?._uid}`;

  if (!blok?.title && facts.length === 0) {
    return null;
  }

  return (
    <section {...storyblokEditable(blok)} className="pt-12 lg:pt-20">
      {/* Recolors any uploaded icon to the brand green, regardless of its own colors */}
      <svg width="0" height="0" className="absolute" aria-hidden="true">
        <filter id={iconFilterId} colorInterpolationFilters="sRGB">
          <feFlood floodColor="#006837" />
          <feComposite in2="SourceAlpha" operator="in" />
        </filter>
      </svg>
      <Container>
        {blok?.title && (
          <FancyTitle
            text={blok.title}
            tag="h2"
            textAlign="text-left"
            marginBottom="mb-6"
          />
        )}

        {facts.length > 0 && (
          <dl className="flex flex-wrap justify-center gap-x-6 gap-y-14 pt-9 lg:gap-y-12 lg:pt-24">
            {facts.map((fact, index) => {
              const key = fact?._uid || `${fact?.label || 'fact'}-${index}`;
              const iconUrl = fact?.icon?.filename;
              return (
                <div
                  className="flex flex-col items-center text-center w-[calc(50%_-_0.75rem)] lg:w-[calc(25%_-_1.125rem)]"
                  key={key}
                >
                  {iconUrl && (
                        <img
                          src={iconUrl}
                          alt={getStoryblokAlt(fact?.icon, '')}
                          width={48}
                          height={48}
                          loading="lazy"
                          className="w-12 h-12 mb-2.5 object-contain"
                          style={{ filter: `url(#${iconFilterId})` }}
                        />
                      )}
                  <dt className="text-[16px] leading-[24px] font-semibold mb-1">
                    {fact?.label}
                  </dt>
                  <dd className="text-[16px] leading-[24px] mt-0">
                    {fact?.value}
                  </dd>
                </div>
              );
            })}
          </dl>
        )}
      </Container>
    </section>
  );
}
